import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../Button";

export function SliderChunk({ items, renderCard }: {
  items: any[];
  renderCard: (item: any) => React.ReactNode;
}) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ slidesToScroll: 1 });

  return (
    <div className="relative mb-8">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {items.map((item, index) => (
            <div key={index} className="min-w-[47%] lg:min-w-[20%] p-2">
              {renderCard(item)}
            </div>
          ))}
        </div>
      </div>

      <Button
        variant="outline"
        size="icon"
        onClick={() => emblaApi?.scrollPrev()}
        className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white shadow-lg hover:bg-gray-50 hidden md:flex"
      >
        <ChevronLeft className="w-5 h-5" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={() => emblaApi?.scrollNext()}
        className="absolute right-0 top-1/2 translate-x-4 -translate-y-1/2 bg-white shadow-lg hover:bg-gray-50 hidden md:flex"
      >
        <ChevronRight className="w-2 h-5" />
      </Button>
    </div>
  );
}